import React, { useState, useEffect } from 'react';
import RecipeGenerator from './RecipeGenerator';
import MealPlanGenerator from './MealPlanGenerator';
import FitnessProgramGenerator from './FitnessProgramGenerator';
import TrendsAnalysis from './TrendsAnalysis';
import SmartShopping from './SmartShopping';
import WhatCanICook from '../WhatCanICook';

const AIAssistantHub = ({ user, token, fetchWithAuth, initialTool, onClose, onSuccess, onViewRecipe }) => {
  const [activeTool, setActiveTool] = useState(null);
  
  // Handle initialTool prop - open specific tool directly if provided
  useEffect(() => {
    if (initialTool) {
      setActiveTool(initialTool);
    }
  }, [initialTool]);

  const tools = [
    {
      id: 'recipe',
      icon: '🍳',
      title: 'Recipe Generator',
      description: 'Create smart recipes from your profile',
      component: RecipeGenerator
    },
    {
      id: 'meal-plan',
      icon: '📅',
      title: 'Meal Plan',
      description: 'Generate personalized meal plans',
      component: MealPlanGenerator
    },
    {
      id: 'fitness-program',
      icon: '🏋️',
      title: 'Fitness Program',
      description: 'AI-powered workout plans with exercise videos',
      component: FitnessProgramGenerator
    },
    {
      id: 'trends',
      icon: '📈',
      title: 'Trends & Analysis',
      description: 'Track progress & get AI recommendations',
      component: TrendsAnalysis
    },
    {
      id: 'shopping',
      icon: '🛒',
      title: 'Smart Shopping',
      description: 'Pantry check + shopping list generator',
      component: SmartShopping
    },
    {
      id: 'what-can-i-cook',
      icon: '🍳',
      title: 'What Can I Cook?',
      description: 'Find recipes matching your pantry',
      component: WhatCanICook
    }
  ];

  if (activeTool) {
    const ActiveComponent = tools.find(t => t.id === activeTool)?.component;
    if (!ActiveComponent) return null;
    return (
      <div className="page-layout">
        <ActiveComponent
          user={user}
          token={token}
          fetchWithAuth={fetchWithAuth}
          onViewRecipe={onViewRecipe}
          onClose={() => {
            setActiveTool(null);
            if (onClose) onClose();
          }}
          onBack={() => setActiveTool(null)}
          onSuccess={() => {
            setActiveTool(null);
            if (onSuccess) onSuccess();
          }}
        />
      </div>
    );
  }

  return (
    <div className="page-layout">
      <div className="page-sticky-nav">
        <div className="page-header-row">
          <h2 className="page-section-title">AI Assistant</h2>
          <button className="page-exit-btn" onClick={onClose}>← Dashboard</button>
        </div>
        <div className="page-nav-bar"></div>
      </div>

      <div className="page-scroll-content">
        {/* Welcome Message */}
        <div className="aih-welcomeSection">
          <p className="aih-welcomeMessage">
            Welcome, <strong>{user?.username || 'User'}</strong>! Your AI assistant is ready to help you achieve your health and fitness goals.
          </p>
        </div>

        {/* Tool Grid */}
        <div className="aih-toolGrid">
          {tools.map(tool => (
            <div
              key={tool.id}
              onClick={() => setActiveTool(tool.id)}
              className={`aih-toolCard ${tool.highlight ? 'aih-toolCard--highlight' : ''}`}
            >
              {tool.highlight && (
                <span className="aih-newBadge">
                  NEW
                </span>
              )}
              <div className="aih-toolIcon">{tool.icon}</div>
              <h3 className="aih-toolTitle">
                {tool.title}
              </h3>
              <p className="aih-toolDescription">
                {tool.description}
              </p>
              <button className="aih-startButton">
                Get Started
              </button>
            </div>
          ))}
        </div>

        {/* Footer Tip */}
        <div className="aih-footerTip">
          <p className="aih-tipText">
            <span></span>
            <span>All AI tools use your complete health profile for personalized recommendations</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIAssistantHub;